<template>
  <div class="menu_container">

    <el-menu style="margin-top: 50px" :collapse="isCollapse" :unique-opened="true" router :default-active="activeMenu">



      <!-- <el-submenu index="1" class="title">
        <template slot="title"><i class="el-icon-star-on"></i>置顶</template>
        <el-menu-item-group>
          <el-menu-item index="1-2"
            @click="$router.push({ name: 'ana', params: { title: '置顶' } })">AI对话概要</el-menu-item>
        </el-menu-item-group>
      </el-submenu> -->


      <el-submenu index="3" class="title">
        <template slot="title"><i class="el-icon-s-order"></i>订单</template>
        <el-menu-item-group>
          <el-menu-item index="/order_list">订单列表</el-menu-item>
          <el-menu-item index="/iframe?url=/api/aichat_admin/order/create_order.html">订单创建</el-menu-item>
        </el-menu-item-group>
      </el-submenu>


      <el-submenu index="4" class="title">
        <template slot="title"><i class="el-icon-setting"></i>配置</template>
        <el-menu-item-group>
          <el-menu-item index="/SimpleSetting">快捷配置</el-menu-item>
          <el-menu-item index="/adminsetting2">共用配置</el-menu-item>
          <el-menu-item index="/EcsServer">服务器</el-menu-item>
          <el-menu-item index="/income_relationship">推广关系</el-menu-item>
          <el-menu-item index="/cicd_file">CICD文件</el-menu-item>
          <el-menu-item index="/chat_rule">客服知识库</el-menu-item>
        </el-menu-item-group>
      </el-submenu>


      <el-submenu index="5" class="title">
        <template slot="title"><i class="el-icon-s-grid"></i>存储</template>
        <el-menu-item-group>
          <el-menu-item index="/FileManage">文件管理</el-menu-item>
          <el-menu-item index="/ShortLink">短链管理</el-menu-item>
        </el-menu-item-group>
      </el-submenu>


      <el-submenu index="6" class="title">
        <template slot="title"><i class="el-icon-s-grid"></i>软著业务</template>
        <el-menu-item-group>
          <el-menu-item index="/iframe?url=https://www.kdocs.cn/l/ckdPfVazs8pF">订单列表</el-menu-item>
        </el-menu-item-group>
      </el-submenu>

      <el-submenu index="7" class="title">
        <template slot="title"><i class="el-icon-mobile-phone"></i>鸿蒙相关</template>
        <el-menu-item-group>
          <el-menu-item index="/HarmonyAppManage">应用管理</el-menu-item>
          <el-menu-item index="/HarmonyMauAnalysis">月活分析</el-menu-item>
          <el-menu-item index="/HarmonyQiyeweixinUser">企微用户</el-menu-item>
          <el-menu-item index="/GzhMassSend">公众号群发</el-menu-item>
          <el-menu-item index="/WithdrawRecord">红包领取记录</el-menu-item>
          <el-menu-item index="/HarmonyNewUserBlacklist">新人黑名单</el-menu-item>
          <el-menu-item index="/AppAssignAnalysis">应用分配分析</el-menu-item>
          <el-menu-item index="/ErrorCodeView">错误代码查看</el-menu-item>
          <el-menu-item index="/ServiceVisitAnalysis">客服访问分析</el-menu-item>
          <el-menu-item index="/HarmonyAgcAnalysis">AGC分析</el-menu-item>
        </el-menu-item-group>
      </el-submenu>

      <el-submenu index="8" class="title">
        <template slot="title"><i class="el-icon-data-analysis"></i>广告推广</template>
        <el-menu-item-group>
          <el-menu-item index="/ad/monitor_analysis">监测分析</el-menu-item>
          <el-menu-item index="/ad/jinghong_analysis">鲸鸿动能分析</el-menu-item>
        </el-menu-item-group>
      </el-submenu>

      <div>
        <div style="text-align: center;" class="ban"></div>
      </div>
      <div class="fl_cen" style="margin-top: 40px;">
      <div class="fold_btn" @click="toggleSidbar">
        <i class="el-icon-s-fold icon_fold pointer"></i>
      </div>
    </div>
    </el-menu>
  </div>
</template>

<script>
export default {
  props: {
    isCollapse: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      activeMenu: ''
    };
  },
  created() {
    this.updateActiveMenu(this.$route);
  },
  methods: {
    toggleSidbar() {
      this.$emit("toggleSidbar");
    },
    updateActiveMenu(route) {
      // 处理带参数的 URL
      if (route.path.includes('/iframe') && route.query.url) {
        this.activeMenu = `/iframe?url=${route.query.url}`;
      } else {
        this.activeMenu = route.path;
      }
    }
  },
  watch: {
    $route: {
      handler(route) {
        this.updateActiveMenu(route);
      },
      immediate: true
    }
  }
};
</script>
<style>
.el-submenu .el-menu-item {
  min-width: unset;
}

.el-menu {
  position: relative;
  border-right: 0;
}

.el-menu::-webkit-scrollbar {
  display: none;
}

.img {
  margin-right: 8px;
  padding-left: 5px;
  width: 16px;
}

.el-icon-fold {
  font-size: 18px;
}

.el-submenu__title {
  padding: 13px 20px 13px 24px;
  color: rgba(48, 49, 51, 1);
}

.el-submenu__icon-arrow {
  margin-top: -3px;
}

itle i {
  color: rgba(48, 49, 51, 1);
}

.el-menu-item.is-active {
  color: rgba(64, 158, 255, 1);
}

.fold_btn {
  right: 6px;
  width: 36px;
  height: 32px;
  border-radius: 4px;
  background: rgba(245, 247, 250, 1);
  display: flex;
  justify-content: center;
  align-items: center;
}

.wd40 .fl_cen {
  margin-top: 10px;
  margin-right: 14px;
}

.wd40 .ban {
  display: none;
}
</style>
